/**
 * return a decimal bps discount value
 * @param bps bps discount
 */ export var bpsToDecimal = function(bps) {
    return (bps !== null && bps !== void 0 ? bps : 0) / 10000;
};
/**
 * return a percent bps discount value
 * @param bps bps discount
 */ export var bpsToPercent = function(bps) {
    return (bps !== null && bps !== void 0 ? bps : 0) / 100;
};
